import { Component, Inject, OnInit } from '@angular/core';
import { ErrorObject } from '@inmoment/the-kitchen';

import { MAT_DIALOG_DATA, MatDialogRef } from 'app/services/dialog.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { WidgetDataSource } from '../../../../models';

@EnableClassTelemetry()
@Component({
  selector: 'app-widget-group-datasource-selector',
  templateUrl: './widget-group-datasource-selector.component.html',
  styleUrls: ['./widget-group-datasource-selector.component.scss'],
  standalone: false,
})
export class WidgetGroupDataSourceSelectorDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  isVisible = false;
  widgetGroupNameStatus: ErrorObject | null;

  dataSources: any;
  previousDataSourceId;
  selectedDataSource: WidgetDataSource;

  constructor(
    private dialogRef: MatDialogRef<WidgetGroupDataSourceSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dataSources = data.dataSources;
    this.previousDataSourceId = data.previousDataSourceId;
  }

  ngOnInit() {
    this.isVisible = true;
  }

  public cancel(): void {
    this.isVisible = false;
    this.dialogRef.close(false);
  }

  public async confirm(): Promise<void> {
    this.dialogRef.close({ dataSource: this.selectedDataSource });
  }
}
